(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("axios"));
	else if(typeof define === 'function' && define.amd)
		define(["axios"], factory);
	else if(typeof exports === 'object')
		exports["axios-auth-refresh"] = factory(require("axios"));
	else
		root["axios-auth-refresh"] = factory(root["axios"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__300__) {
return 